import { render, staticRenderFns } from "./main.vue?vue&type=template&id=946cae68&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=946cae68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946cae68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('946cae68')) {
      api.createRecord('946cae68', component.options)
    } else {
      api.reload('946cae68', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=946cae68&scoped=true&", function () {
      api.rerender('946cae68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mitumori/main.vue"
export default component.exports